import type { IntercomSettings } from '@/types/intercom'
import type { User } from '@/types/user'

/**
 * 设置 Intercom 用户信息
 */
export function setIntercomSettings(user: Partial<User>) {
  if (!user || !user.id) {
    return
  }

  // 检查是否禁用 Intercom
  const noIntercom = sessionStorage.getItem('no_intercom')
  if (noIntercom === '1') {
    return
  }

  // 构建用户信息，排除虚拟邮箱
  const userInfo: Partial<IntercomSettings> = { name: user.name }
  if (user.email && !user.email.includes('@shopify-fake.com')) {
    userInfo.email = user.email
  }

  const teamName = user.team_name || 'creator'

  console.log('设置 Intercom 用户信息:', { ...userInfo, teamName, ...user })

  // 设置 Intercom 配置
  window.intercomSettings = {
    api_base: 'https://api-iam.intercom.io',
    app_id: 'j8ewhz82',
    user_id: user.id,
    user_hash: user.hash,
    team_id: user.team_id,
    team_name: teamName,
    ...userInfo,
  }

  // 更新 Intercom
  if (typeof window.Intercom === 'function') {
    try {
      window.Intercom('update', window.intercomSettings)
    }
    catch (error) {
      console.error('Intercom update 失败:', error)
    }
  }
}

/**
 * 打开 Intercom 聊天窗口
 */
export function showIntercom() {
  // 检查 Intercom 是否可用
  if (typeof window.Intercom === 'function') {
    try {
      window.Intercom('show')
    }
    catch (error) {
      console.error('Failed to open Intercom:', error)
      // 如果 Intercom 不可用，提供备用方案
      console.warn('Chat is temporarily unavailable. Please try again later.')
    }
  }
  else {
    // Intercom 未加载，提供备用方案
    console.warn('Intercom is not available. Please contact support through other channels.')
  }
}

/**
 * 显示 Intercom 新消息对话框
 * @param prefilledMessage 可选的预填消息内容
 */
export function showIntercomNewMessage(message?: string) {
  // 检查 Intercom 是否可用
  if (typeof window.Intercom === 'function') {
    try {
      if (message && message.trim().length > 0) {
        window.Intercom('showNewMessage', message)
      }
      else {
        window.Intercom('showNewMessage')
      }
    }
    catch (error) {
      console.error('Failed to open Intercom new message:', error)
      // 如果失败，回退到显示聊天窗口
      showIntercom()
    }
  }
  else {
    // Intercom 未加载，提供备用方案
    console.warn('Intercom is not available. Please contact support through other channels.')
  }
}
